import * as React from "react";
import {Breadcrumbs, Typography, Container, Button, Box, Stack} from "@mui/material";
import Tags from "../tag/Tag";
import {useAdviceDetail} from "./hook/useAdviceDetail";
import StarIcon from "@mui/icons-material/Star";
import {StarOutline} from "@mui/icons-material";
import { useParams } from "react-router-dom";

const AdviceHeader= ({advice}) => {
    const {id} = useParams();
    const {addToFav, removeFromFav} = useAdviceDetail(id);

    return (
        <Stack
            direction="row"
            justifyContent="left"
            alignItems="center"
            spacing={0}
            flexWrap={"wrap"}
        >
            <Box sx={{width : {xs : '100%', md : '100%', lg : '48%'}}}>
                <img style={{width : '-webkit-fill-available'}} src={`/assets/img/advice1.png`} alt="Image conseil" />
            </Box>
            <Box className={'advice-header__box'} sx={{width : '100%', maxWidth : {lg : '49%'}}}>
                <Tags tags={advice.tags}></Tags>
                <Stack direction={"row"} alignItems={"center"} marginTop={"55px"} justifyContent={"space-between"}>
                    <Typography variant={'h2'} color={"#FFFFFF"} alignItems={"center"} sx={{maxWidth:'400px'}}>
                        {advice.title}
                    </Typography>
                    {
                        advice.isFavorite &&
                        <Button className="btn btn-fav" onClick={() => removeFromFav(advice.id) } >
                            <StarIcon role={'img'} aria-label="Enlever des favoris" />
                            <Typography variant={'subtitle6'}>Enlever des favoris</Typography>
                        </Button>
                    }
                    {
                        !advice.isFavorite &&
                        <Button className="btn btn-fav" onClick={ () => addToFav(advice.id) }>
                            <StarOutline role={'img'} aria-label="Ajouter dans mes favoris" />
                            <Typography variant={'subtitle6'}>Ajouter aux favoris</Typography>
                        </Button>
                    }
                </Stack>
            </Box>
        </Stack>
    )
}

export default AdviceHeader;
